import { render } from "./Enrollment.vue?vue&type=template&id=7b509cf4"
import script from "./Enrollment.vue?vue&type=script&lang=js"
export * from "./Enrollment.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__